// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".default .dateinput{position:relative;display:inline-block}.default .dateinput .inp{cursor:pointer}.default .dateinput-label{position:absolute;z-index:9998;right:10px;bottom:0px;cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;height:70%}.default .dateinput-label>*{width:16px;height:16px}.default.opl-sg .dateinput .inp.opened,.opl-sg .dateinput .inp.opened{border-color:#f16e00 !important}", ""]);
// Exports
module.exports = exports;
